import { MiddlewareAPI } from '@reduxjs/toolkit';
import { UserActionPayload } from '@/middlewares/userActionsMiddleware/types';
import InlineAggregateLayer from '@/components/layers/InlineAggregateLayer';
import { trevorAxios } from '@/api';
import { ACTION_COMPLETE_SUMMARIZE } from '@/components/HighlightFeature';
import { IntercomAPI } from '@/integrations/Intercom';
import {
  createActionsData,
  getCurrentState,
  getNextSummarizeStep,
  processAction,
} from './utils';

// temporary alias for convenience sake.
type SummarizeStep = InlineAggregateLayer;

const isNoMetricSummarizeStep = (step: SummarizeStep) =>
  step.functions().length === 0;

const isNoDimensionSummarizeStep = (step: SummarizeStep) =>
  step.keys().length === 0;

const hasNotYetDoneCompleteSummarizeStep = (store: MiddlewareAPI) =>
  !store.getState().datasource.userActions[ACTION_COMPLETE_SUMMARIZE];

const isIncompleteSummarizeStep = (step: SummarizeStep, store: MiddlewareAPI) =>
  isNoMetricSummarizeStep(step) ||
  isNoDimensionSummarizeStep(step) ||
  hasNotYetDoneCompleteSummarizeStep(store);
const isCompleteSummarizeStep: Predicate<SummarizeStep> = (step) =>
  step.functions().length > 0 && step.keys().length > 0;

export const trackSummarizeStepCompleteAction = (
  store: MiddlewareAPI,
  action: UserActionPayload,
  datasourceId?: string,
) => {
  const nextSummarizeStep = getNextSummarizeStep(action);
  if (!nextSummarizeStep) return;

  const currentState = getCurrentState(
    store,
    nextSummarizeStep,
    (current, next) =>
      isIncompleteSummarizeStep(current, store) &&
      isCompleteSummarizeStep(next),
  );
  if (!currentState) return;

  trevorAxios
    .post(
      `datasources/${datasourceId}/actions`,
      createActionsData(ACTION_COMPLETE_SUMMARIZE),
    )
    .then(processAction(ACTION_COMPLETE_SUMMARIZE, store))
    .then(IntercomAPI.ping);
};
